export default __webpack_public_path__ + "static/media/rec2.290e85fd.mp3";